import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesRepository } from 'common/repositories/index';
import { FilterDeviceName } from 'common/filters/index';
import Cookie from 'common/services/util/-RFC.Cookie';

/**
 * Remove device controller
 * Handles remove-device modal template.
 */

angular.module('controllers')
    .controller(
        'RemoveDevice',
        (
            $scope, $stateParams, $state, $filter, Util,
            DeviceRestService, Auth, $rootScope, JWT,
        ) => {

            const deviceId = $stateParams.resourceId;
            $scope.device = DevicesRepository.getById(deviceId);
            $scope.brandName = CWCONFIG.partnerConfig.name;

            // Method to confirm deletion of a device.
            // Triggered by "confirm delete" template button.
            $scope.confirmDelete = () => {

                const devicePromise = DeviceRestService.remove(deviceId);

                // send the DELETE verb permanently delete the device
                devicePromise
                    .then(() => {

                        Alert.success(
                            {
                                message: 'cw.device.remove.success',
                                icon: {
                                    cssClasses: `icon-${Util.deepFind($scope.device, 'attributes.type')}`,
                                },
                            },
                            {
                                message: {
                                    deviceName: FilterDeviceName($scope.device),
                                },
                            },
                        );
                        DevicesRepository.remove(deviceId);

                        const isFromDeviceDetails = $state.current.name.indexOf('device-details') > -1;

                        Mixpanel.send('ConnectWeb Device Remove Click', {
                            Delete: 'true',
                            Page: isFromDeviceDetails ? 'Device Details' : 'My Devices',
                        });

                        // logout user after the deveice is deleted because
                        // the token will not work anymore
                        // (only if the session is from that device)
                        const token = Cookie.get(CWCONFIG.cookie.token) || '';
                        const tokenPayload = JWT.getTokenPayload(token);

                        if (tokenPayload.did && tokenPayload.did === Number(deviceId)) {

                            Auth.logOut();

                        }

                        if (isFromDeviceDetails) {

                            $scope.close();
                            $state.go('root.dashboard.devices');

                        } else {

                            $scope.close();

                        }

                    })
                    .catch(() => {

                        Alert.error(
                            {
                                message: 'cw.device.remove.error',
                                icon: {
                                    cssClasses: `icon-${Util.deepFind($scope.device, 'attributes.type')}`,
                                },
                            },
                            {
                                message: {
                                    deviceName: $filter('deviceName')($scope.device),
                                },
                            },
                        );

                    });

                // clear Digital Health deviceIDs if the device is removed
                delete $rootScope.digitalHealthSelectedDeviceId;
                delete $rootScope.digitalHealthSelectedDevice;

            };

            // Method to cancel and close the the "remove device" lightbox.
            $scope.cancel = () => {

                Util.closeModal();

            };

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/remove-device.js